angular.module( 'acme.view.application.coupons.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.coupons.create.controllers',
  'acme.view.application.coupons.create.detail',
  'acme.view.application.coupons.create.schedule'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var couponsCreate = {
        name: 'application.coupons.create',
        url: '/create/:couponId',
        views: {
          "subview-main": {
            controller: 'CouponsCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/coupons/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Coupons',
          /** Secure With Roles **/
          permissions: ['COUPONS_VIEW']
        }
      };

    $stateProvider
      .state(couponsCreate);
});
